import { useRouteLoaderData } from 'react-router'
import { type flags } from '#app/feature-flags.ts'
import { type loader as rootLoader } from '#app/root.tsx'
import { type SerializeFrom } from './types'

function isUser(user: any): user is SerializeFrom<typeof rootLoader>['user'] {
	return user && typeof user === 'object' && typeof user.id === 'string'
}

export function useOptionalUser() {
	const data = useRouteLoaderData<typeof rootLoader>('root')
	if (!data || !isUser(data.user)) {
		return undefined
	}
	type FeatureFlagSlug = (typeof flags)[number]['slug']
	return {
		...data.user,
		hasFeatureFlag: (slug: FeatureFlagSlug) => data.user.featureFlags?.some(flag => flag.slug === slug),
	}
}

export function useUser() {
	const maybeUser = useOptionalUser()
	if (!maybeUser) {
		throw new Error(
			'No user found in root loader, but user is required by useUser. If user is optional, try useOptionalUser instead.',
		)
	}
	return maybeUser
}
